<svg-icon [src]="src" [svgStyle]="svgStyle"></svg-icon>
